import { AdminRepository } from '../repositories/admin.repository'
import type {
  AuthSession,
  AuthUser,
  DatabaseProbe,
  ProfileRow,
} from '../types/database.types'
import { unwrap } from './result'

const ADMIN_TABLES = [
  'niches',
  'sources',
  'objections',
  'products',
  'prospects',
  'activities',
  'follow_ups',
  'sales',
  'payments',
  'goals',
] as const

export const AdminService = {
  isConfigured: AdminRepository.isConfigured(),
  configurationError: AdminRepository.configurationError(),

  async signIn(email: string, password: string): Promise<AuthSession> {
    return unwrap(await AdminRepository.signIn(email, password))
  },

  async signOut(): Promise<void> {
    unwrap(await AdminRepository.signOut())
  },

  async getSession(): Promise<AuthSession | null> {
    return unwrap(await AdminRepository.getSession())
  },

  async getCurrentUser(): Promise<AuthUser | null> {
    return unwrap(await AdminRepository.getCurrentUser())
  },

  async getProfile(userId: string): Promise<ProfileRow | null> {
    return unwrap(await AdminRepository.getProfile(userId))
  },

  subscribeToAuth(callback: () => void): () => void {
    return AdminRepository.subscribeToAuth(callback)
  },

  async checkDatabase(): Promise<DatabaseProbe[]> {
    return AdminRepository.probeTables(ADMIN_TABLES)
  },
}
